export default __webpack_public_path__ + "static/media/blog_image.c4d8fc83.png";